/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ComponentGridFilter, CostCenterRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { CostCenterCheckUsage, CostCenterListItem } from './cost-center-list-item.model';

@Injectable()
export class EstimatingCostCenterListTabBusinessService implements InitViewService {
  constructor(private costCenterRest: CostCenterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('costCenters'),
    };
  }

  findAllAsDataSource(filter: ComponentGridFilter): SlicedDataSource<CostCenterListItem> {
    return this.costCenterRest.findAllAsDataSource(filter);
  }

  checkUsage(costCenter: CostCenterListItem): Observable<CostCenterCheckUsage> {
    return this.costCenterRest.checkUsage(costCenter);
  }

  deactivateOrDelete(costCenter: CostCenterListItem, takeOffParamCheckUsage: CostCenterCheckUsage): Observable<any> {
    return this.costCenterRest.deactivate(costCenter, takeOffParamCheckUsage);
  }

  activate(costCenter: CostCenterListItem): Observable<CostCenterListItem> {
    return this.costCenterRest.activate(costCenter);
  }
  bulkDelete(items: any[]): Observable<any> {
    return this.costCenterRest.bulkDelete(items);
  }
}
